module.exports = __webpack_public_path__ + "static/media/locks.34882276.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/locks.svg
// module id = 194
// module chunks = 0